import { RichTextModulePropertiesModel } from '@/client';
import { Box, HeadingTag, Link, ModuleBase, RichText, Text } from '@/components';
import React from 'react';

const RichTextModule = ({ data, moduleName }: { data: RichTextModulePropertiesModel; moduleName: string }) => {
  return (
    <ModuleBase data={data} moduleName={moduleName}>
      {data.preHeading && (
        <Text className="container my-4 text-xs font-semibold uppercase text-white/50 md:text-sm">
          {data.preHeading}
        </Text>
      )}
      {data.headingTitle && (
        <HeadingTag data={{ heading: data.headingTitle }} className="container mt-7 text-3xl md:text-5xl" />
      )}

      {data.content && <RichText data={data.content} className="richtext-content container mt-5 md:mt-10" />}

      {(data.primaryCTA || data.secondaryCTA) && (
        <Box className="container mt-10 flex gap-4">
          {data.primaryCTA && (
            <Link
              className="inline-flex h-10 items-center rounded-md border px-3 py-2 text-sm hover:bg-white hover:text-black"
              link={data.primaryCTA[0]}
            />
          )}
          {data.secondaryCTA && (
            <Link
              className="inline-flex h-10 items-center rounded-md border border-white/25 px-3 py-2 text-sm hover:bg-white/25 hover:text-white"
              link={data.secondaryCTA[0]}
            />
          )}
        </Box>
      )}
    </ModuleBase>
  );
};

export default RichTextModule;
